import { NavigationClient, type NavigationOptions } from '@azure/msal-browser';
import type { Router } from 'vue-router';

/**
 * Overrides the default navigation function of MSAL to work with the vue router.
 */
export class RouterNavigationClient extends NavigationClient {
    private router: Router;

    constructor(router: Router) {
        super();
        this.router = router;
    }

    get baseUrl(): string {
        const basePath = this.router.options.history.base;
        if (!basePath) return window.location.origin;
        return `${window.location.origin}${basePath}`;
    }

    // http://localhost:5173/gino-client#error=unauthorized_client&error_description=AADB2C90058%3a+The+provided+application+is+not+configured+to+allow+public+clients.%0d%0aCorrelation+ID%3a+47baaef0-530e-446e-9536-78d831ae3409%0d%0aTimestamp%3a+2023-12-07+13%3a36%3a54Z%0d%0a&state=eyJpZCI6IjZiZGZiZmQ4LWQ3ZGEtNGFkYi1hNzE0LTFlMjdmZTJiOTllMiIsIm1ldGEiOnsiaW50ZXJhY3Rpb25UeXBlIjoicmVkaXJlY3QifX0%3d

    protected getRelativePath(url: string) {
        console.log('BASE URL', this.baseUrl);
        return url.replace(this.baseUrl, '');
    }

    /**
     * Navigates to other pages within the same web application
     * You can use the useHistory hook provided by react-router-dom to take advantage of client-side routing
     * @param url
     * @param options
     */
    async navigateInternal(url: string, options: NavigationOptions) {
        const relativePath = this.getRelativePath(url);
        console.log('RELATIVE PATH', relativePath);
        if (options.noHistory) {
            this.router.replace(relativePath);
        } else {
            this.router.push(relativePath);
        }

        return false;
    }
}
